var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1119 28.4445L22.0008 21.3333L14.8896 28.4445",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.3333V37.3333",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9161 32.6934C38.6501 31.7481 40.0198 30.2523 40.8093 28.442C41.5987 26.6318 41.7627 24.6102 41.2756 22.6964C40.7885 20.7825 39.6779 19.0854 38.1191 17.8728C36.5603 16.6603 34.6421 16.0013 32.6673 16H30.4273C29.8891 13.9187 28.8862 11.9864 27.4938 10.3485C26.1014 8.71053 24.3559 7.40955 22.3883 6.54334C20.4208 5.67713 18.2824 5.26823 16.1341 5.34738C13.9858 5.42654 11.8834 5.99168 9.9849 7.00033C8.08642 8.00898 6.44131 9.43489 5.17324 11.1708C3.90517 12.9068 3.04714 14.9077 2.66366 17.023C2.28017 19.1383 2.38121 21.313 2.95918 23.3836C3.53715 25.4542 4.57701 27.3669 6.00058 28.9778",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1119 28.4445L22.0008 21.3333L14.8896 28.4445",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgUploadCloud;